import { Redirect, Route, Switch } from "react-router-dom"
import Layout from "./components/Layout"
import Routes, { RoutesType } from "./components/Routes"
import ConnectExtension from "./components/ConnectExtension"
import { ErrorBoundary, FallbackProps } from "react-error-boundary"
import Oops from "./components/Oops/Oops"
import { SignalrClient } from "./components/SignalrClient"
import i18n from "./i18n"
import { I18nextProvider } from "react-i18next"
import { SnackBars } from "./components/Config/SnackBars"

const App = () => {
  const isNotIframe = window === window.parent

  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <ConnectExtension>
          <SignalrClient>
            <SnackBars />
            <Switch>
              {Routes.map((r: RoutesType, i: number) => (
                <Route key={`app-route-${i}`} exact={r.exact} path={r.path}>
                  <Layout>{r.main}</Layout>
                </Route>
              ))}
              {isNotIframe && (
                <Route>
                  <Redirect to="/config" />
                </Route>
              )}
            </Switch>
          </SignalrClient>
        </ConnectExtension>
      </ErrorBoundary>
    </I18nextProvider>
  )
}

// Custom error fallback to make it fit in a card with proper formatting
const ErrorFallback = (props: FallbackProps) => <Oops body={props.error.message} />

export default App
